<template>
  <CustomUpdateDialog
    dialogTitle="تغییر وضعیت کلاس ترمیک به در حال ثبت نام"
    dialogId="update-termic-courses-status-dialog"
    okTitle="بله"
    cancelTitle="خیر"
    :isOkDisabled="isLoading"
    @ok="sendUpdateTermicCourseStatusRequest"
  >
    <BCol cols="12">
      <p>
        آیا از تغییر وضعیت کلاس ترمیک
        <span style="font-weight: bold">{{
          termicCourseDetails && termicCourseDetails.termicCourseName
            ? termicCourseDetails.termicCourseName
            : ""
        }}</span>
        به در حال ثبت نام اطمینان دارید؟
      </p>
    </BCol>
  </CustomUpdateDialog>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    termicCourseDetails: {
      type: Object,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    async sendUpdateTermicCourseStatusRequest() {
      try {
        this.isLoading = true;
        const _this = this;
        let changeTermicCourseStatusToAvailable =
          new ChangeTermicCourseStatusToAvailable(_this);
        changeTermicCourseStatusToAvailable.setRequestParam({
          termicCourseId: this.termicCourseDetails.id,
        });
        await changeTermicCourseStatusToAvailable.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "وضعیت کلاس ترمیک به در حال ثبت نام تغییر کرد.",
              },
            });
            this.$bvModal.hide("update-termic-courses-status-dialog");
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    CustomUpdateDialog,
    BCol,
  },
};
import CustomUpdateDialog from "@/views/components/Utils/Dialogs/CustomUpdateDialog.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { BCol } from "bootstrap-vue";
import { ChangeTermicCourseStatusToAvailable } from "@/libs/Api/TermicCourses";
</script>
